module.exports = __webpack_public_path__ + "media/ringtone.4475b432.mp3";